import { render } from "./ProfileProviderComponent.vue?vue&type=template&id=1ab408c2&scoped=true"
import script from "./ProfileProviderComponent.vue?vue&type=script&lang=js"
export * from "./ProfileProviderComponent.vue?vue&type=script&lang=js"

import "./ProfileProviderComponent.vue?vue&type=style&index=0&id=1ab408c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab408c2"]])

export default __exports__